import * as React from 'react';
import alert from '../../assets/alert.svg';

export interface DeclineReasonBubbleProps {
  title: string;
  action_item: string;
}

export const DeclineReasonBubble: React.FC<DeclineReasonBubbleProps> = (
  props
) => {
  return (
    <span
      className="flex rounded-lg p-3.5 text-left mb-4 mt-2"
      style={{ backgroundColor: 'rgba(247, 59, 74, 0.12)' }}
    >
      <span className="min-w-fit mr-3">
        <img src={alert} alt="document declined" />
      </span>
      <span className="flex flex-col">
        <div className="inline text-sm font-semibold mb-1">{props.title}</div>
        <div className="inline text-sm">{props.action_item}</div>
      </span>
    </span>
  );
};
